import { buyXSaveY, buyXSaveYAddToCart } from './product/TieredDiscounts'

// useCurrencyHydration.js
// think about the scenarios and modify switch cases accordingly
export const setCurrencyAndPopIn = (
  localCurrency,
  node_locale,
  country,
  setCurrencyPopIn,
  sessionStorageCurrencyUpdated,
) => {
  // currency will be dispatched to context and manage price displays
  let currency
  let currencyPopIn

  switch (node_locale) {
    // landing on en-GB
    // en-GB should always show GBP prices
    case 'en-GB':
      switch (true) {
        case localCurrency === 'GBP':
          currencyPopIn = null
          break
        case localCurrency === 'EUR':
          // if user updated currency, the pop in will not be triggered
          sessionStorageCurrencyUpdated
            ? (currencyPopIn = null)
            : (currencyPopIn = {
                currency: { code: 'EUR', symbol: '€' },
                country: country,
              })
          break
      }
      break
    case 'en-US':
      switch (true) {
        case localCurrency === 'USD':
          currencyPopIn = null
          break
        case localCurrency === 'EUR':
          // if user updated currency, the pop in will not be triggered
          sessionStorageCurrencyUpdated
            ? (currencyPopIn = null)
            : (currencyPopIn = {
                currency: { code: 'EUR', symbol: '€' },
                country: country,
              })
          break
      }
      break
    // landing on the other locales
    default:
      switch (true) {
        case localCurrency === 'GBP':
          sessionStorageCurrencyUpdated
            ? (currencyPopIn = null)
            : (currencyPopIn = {
                currency: { code: 'GBP', symbol: '£' },
                country: country,
              })
          break
        case localCurrency === 'EUR':
          currencyPopIn = null
          break
      }
  }

  setCurrencyPopIn(currencyPopIn)
}

// useCurrencyHydration.js
// countryCode comes from GeoIp
// setCountry for currency pop-in display
// setLocalCurrency for updating currency in SettingsContext
export const matchCurrencyCode = (countryCode, setState) => {
  let country = null
  let localCurrency = null

  switch (countryCode) {
    case 'GB':
      country = 'GB'
      localCurrency = 'GBP'
      break
    case 'NL':
      country = 'NL'
      localCurrency = 'EUR'
      break
    case 'DE':
      country = 'DE'
      localCurrency = 'EUR'
      break
    case 'FR':
      country = 'FR'
      localCurrency = 'EUR'
      break
    case 'US':
      country = 'US'
      localCurrency = 'USD'
      break
    default:
      country = 'NL'
      localCurrency = 'EUR'
  }

  setState([country, localCurrency])
}

// CurrencySelect.js
// for currency select options
// node_locale is for navigating to the correct locale
export const matchCurrencyLocale = (currency) => {
  switch (currency) {
    case 'GBP':
      return { code: 'GBP', symbol: '£', node_locale: 'en-GB' }
    case 'USD':
      return { code: 'USD', symbol: '$', node_locale: 'en-US' }
    default:
      return { code: 'EUR', symbol: '€', node_locale: 'en' }
  }
}

// LanguageSelect.js
// node_locale comes from user selection
// what is returned will create new checkout in the correct currency
export const matchLocaleCurrency = (node_locale) => {
  switch (node_locale) {
    case 'en-GB':
      return 'GBP'
    case 'en-US':
      return 'USD'
    default:
      return 'EUR'
  }
}

// CurrencyPopIn.js
// setLanguage for pop-in displaying the language to which the visitor will be directed
// setNodeLocale for navigating to the correct locale
// languages from Contentful, add more when necessary
export const matchCountryToLanguage = (
  country,
  setLanguage,
  set_node_locale,
  context,
) => {
  const { dutch, english, german, french, italian, swedish } = context

  switch (country) {
    case 'NL':
      setLanguage(dutch)
      set_node_locale('nl')
      break
    case 'GB':
      setLanguage(english)
      set_node_locale('en-GB')
      break
    case 'DE':
      setLanguage(german)
      set_node_locale('de')
      break
    case 'FR':
      setLanguage(french)
      set_node_locale('fr')
      break
    case 'US':
      setLanguage(english)
      set_node_locale('en-US')
      break
    case 'SV':
      setLanguage(swedish)
      set_node_locale('sv')
      break
    case 'IT':
      setLanguage(italian)
      set_node_locale('it')
      break
  }
}

// CurrencyPopIn.js
// the returned value is for displaying the currency to which the visitor will be directed
export const matchCurrency = (currencyCode, currencies) => {
  return currencies[currencyCode]
}

// ProductForm.js
export const getProductFormPrice = (node_locale, quantity, checkouts) => {
  switch (node_locale) {
    case 'en-GB':
      return buyXSaveYAddToCart(2, 5, quantity, checkouts)
    default:
      return buyXSaveYAddToCart(2, 5, quantity, checkouts)
  }
}

// Cart.js
export const getCartBundleDiscountAmount = (
  node_locale,
  amountOfEligibleDiscountProducts,
  priceOfEligibleDiscountProducts,
) => {
  switch (node_locale) {
    case 'en-GB':
      return buyXSaveY(2, 5, amountOfEligibleDiscountProducts)
    case 'en-US':
      // en-US - BlackFriday f** percentages
      return (Math.round(priceOfEligibleDiscountProducts * 100) / 100).toFixed(
        2,
      )
    default:
      return buyXSaveY(2, 5, amountOfEligibleDiscountProducts)
  }
}

// Bundle.js
export const getBundleDiscountAmount = (node_locale, productAmount) => {
  switch (node_locale) {
    case 'en-GB':
      return buyXSaveY(2, 5, productAmount)
    default:
      return buyXSaveY(2, 5, productAmount)
  }
}

// FamilyReviews.js
// en-GB shows en reviews
export const getLocale = (node_locale) => {
  switch (node_locale) {
    case 'en-GB':
    case 'en-US':
      return 'en'
    default:
      return node_locale
  }
}

// useProductTitleTranslation.js
// e.g. Shopify doesn't accept 'en-GB' as language in query
export const getShopifyLanguage = (node_locale) => {
  switch (node_locale) {
    case 'en-GB':
    case 'en-US':
      return 'en'
    default:
      return node_locale
  }
}

// add currency symbol and discount in Shopify Scripts

// Add Contentful new node_locale contents
